/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Extend from 'flarum/common/extenders';
import { default as extend } from '../common/extend';
import User from 'flarum/common/models/User';

import Rank from '../common/models/Rank';
import GlobalStats from '../common/models/GlobalStats';
import LeaderboardPage from './leaderboards/components/LeaderboardPage';
import LevelHistory from './levels/models/LevelHistory';
import AchievementsPage from './achievements/components/AchievementsPage';
import AchievementPage from './achievements/components/AchievementPage';
import AchievementUsersPage from './achievements/components/AchievementUsersPage';
import AchievementsProfilePage from './achievements/components/AchievementsProfilePage';

export default [
	...extend,

	new Extend.Store() //
		.add('global_stats', GlobalStats)
		.add('leaderboard_ranks', Rank)
		.add('level_history', LevelHistory),

	new Extend.Model(User) //
		.attribute('activitySummary')
		.attribute('exp')
		.attribute('level')
		.hasMany<User>('userAchievements')
		.hasMany<User>('achievementsCount'),

	new Extend.Routes() //
		.add('leaderboard', '/leaderboard', LeaderboardPage)
		.add('activityLeaderboard', '/leaderboard/:activityType', LeaderboardPage)
		.add('achievements', '/achievements/c/:category', AchievementsPage)
		.add('achievement', '/achievements/:id', AchievementPage)
		.add('achievement-users', '/achievement-users/:levelId', AchievementUsersPage)
		.add('user.achievements', '/u/:username/achievements', AchievementsProfilePage),
];
